export default "__VITE_ASSET__DYJYzS8n__"